import _find from "lodash/find";
import _sortBy from "lodash/sortBy";
import getTime from "date-fns/get_time";
//
import {
  countries,
  genders,
  orientations,
  endowments,
  modelLanguages,
  modelLanguageLevels,
} from "../config";

export const isTouchDevice = "ontouchstart" in document.documentElement;

export function find(coll, id) {
  return _find(coll, ["id", id]);
}

export function cloneDate(date) {
  return new Date(date.getTime());
}

export function getUnixTimestamp(date) {
  return Math.ceil(getTime(date) / 1000);
}

export function formatMoney(num, countryId) {
  const digits = 0;
  const decimal = ".";
  const thousands = ",";

  let price = "";

  let i = parseInt((num = Math.abs(+num || 0).toFixed(digits))) + "";
  let j = i.length;

  j = j > 3 ? j % 3 : 0;

  if (num < 0) price += "-";
  if (j) price += i.substr(0, j) + thousands;

  price += i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);

  if (digits)
    price +=
      decimal +
      Math.abs(num - i)
        .toFixed(digits)
        .slice(2);

  if (countryId) {
    const country = getCountry(countryId);

    return `${country.currencySymbol} ${price}`;
  }

  return price;
}

export function getUrlParameter(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function _addIf(arr1, value) {
  const arr2 = arr1.filter((val) => val !== value);

  return arr2.length === arr1.length ? arr1.concat(value) : arr2;
}

const txts = {
  brand: "Agency",
  gender: "Gender",
  cup: "Cup size",
  age: "Age",
  height: "Height",
  female: "Female",
  trans: "Transgender",
  services: "Services",
  endowment: "Endowment",
  orientation: "Orientation",
  "post-op": "Post op",
  "pre-op": "Pre op",
  bottom: "Bottom",
  top: "Top",
  versatile: "Versatile",
  small: "Small",
  medium: "Medium",
  large: "Large",
  // weight: "Weight",
  // heavy: "Heavy",
  // light: "Light",
  bodyType: "Body type",
  avg: "Average",
  independent: "Independent",
};

// val: filter value ('female', '24-29', 'tall'...)
// key: filter name ('gender', 'age', 'height'...)
export function mapTag(val, key, brands) {
  if (key === "brand" && val !== "") {
    if (val === null) {
      val = "independent";
    } else {
      val = brands[val].name;
    }
  } else if (key === "services") {
    val = val.length;
  }

  return {
    filter: key,
    name: txts[key],
    value: txts[val] || val,
  };
}

export function getGenderName(val) {
  const gender = _find(genders, (obj) => obj.id === val);
  return gender.name;
}

export function getOrientationName(val) {
  const orientation = _find(orientations, (obj) => obj.id === val);
  return orientation.name;
}

export function getEndowmentName(val) {
  const endowment = _find(endowments, (obj) => obj.id === val);
  return endowment.name;
}

export function intervention(path, template) {
  return `/images/${template}/${path}`;
}

export function getCity(cityId) {
  return _find(cities, (city) => city.id === cityId);
}

export function getCountry(countryId) {
  return _find(countries, (country) => country.id === countryId);
}

export function getLanguageName(val) {
  return modelLanguages[val];
}

export function getLanguageLevelName(val) {
  return modelLanguageLevels[val];
}

export function getHumanDuration(minutes) {
  const hh = getDurationHours(minutes);
  const mm = getDurationMinutes(minutes);
  const human = [];

  if (hh !== 0) {
    human.push(`${hh}h`);
  }

  if (mm !== 0) {
    human.push(`${mm} min`);
  }

  if (human.length) {
    return human.join(" ");
  }

  return minutes;
}

export function getDurationHours(minutes) {
  return Math.floor(minutes / 60);
}

export function getDurationMinutes(minutes) {
  return minutes % 60;
}

export function getRsvpText(rsvp) {
  if (rsvp >= 80) {
    return "Always responds within 10 mins";
  }

  if (rsvp >= 60) {
    return "Usually responds within 10 mins";
  }

  return "Rarely responds within 10 mins";
}

export function showScore(count, score) {
  return count > 2 && score > 0;
}

export function roundNearest(num, near) {
  return Math.ceil(num / near) * near;
}

export function logError(err) {
  if (console && console.error) {
    console.error(err);
  }
}

export function _splice(arr, start, deleteCount, ...items) {
  return [...arr.slice(0, start), ...items, ...arr.slice(start + deleteCount)];
}

export function _pop(arr) {
  return arr.slice(0, -1);
}

export function _push(arr, newEntry) {
  return [...arr, newEntry];
}

export function getCityNear(cities, lat, lng) {
  const sortedByDistance = _sortBy(cities, (city) =>
    getDistance(city.lat, city.lng, lat, lng)
  );

  return sortedByDistance[0];
}

const earthRadius = 6371; // km

export function getDistance(lat1, lng1, lat2, lng2) {
  const dLat = deg2rad(lat2 - lat1);
  const dLng = deg2rad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function isLargeCity(cityId) {
  // return cityId === 1; // DEV: Bangkok
  return cityId === 1000000; // London...
}
